import axios from "../utiles/axios.util";

function apiGetMemoMng(dvyfg_de, keyword) {
    return axios.get(`/api/v1/memoMng?dvyfg_de=${dvyfg_de}&keyword=${keyword}`);
}

function apiGetMemoMngDetail(rcvord_no) {
    return axios.get(`/api/v1/memoMng/detail?rcvord_no=${rcvord_no}`);
}

function apiPutMemoMng(formData) {
    return axios.put("/api/v1/memoMng", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

export { apiGetMemoMng, apiGetMemoMngDetail, apiPutMemoMng };
